import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const getStoredBusiness = (): BusinessType | null => {
  try {
    const raw = localStorage?.getItem('selectedBusiness');
    if (!raw) return null;

    const parsed = JSON.parse(raw) as BusinessType;
    return parsed?.uuid ? parsed : null;
  } catch {
    localStorage.removeItem('selectedBusiness');
    return null;
  }
};

const initialState: BusienssSliceType = {
  businesses: [],
  business: getStoredBusiness(),
};

export const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    setBusinesses: (state: BusienssSliceType, action: PayloadAction<EntityType[]>) => {
      state.businesses = action.payload;
    },
    setBusiness: (state: BusienssSliceType, action: PayloadAction<BusinessType>) => {
      state.business = action.payload;
    },
    resetBusinessState: (state: BusienssSliceType) => {
      state.business = null;
      state.businesses = [];
    },
  },
});

export const { setBusinesses, setBusiness, resetBusinessState } = businessSlice.actions;
export default businessSlice.reducer;
